var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Prop, Emit } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { StrategyConfigService } from "~/services/dataimp-service/strategy-config.service";
var CollectionExecutionModule = namespace("collection-execution");
var PolicyExecutionRecord = /** @class */ (function (_super) {
    __extends(PolicyExecutionRecord, _super);
    function PolicyExecutionRecord() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            name: "",
            caseNumber: "",
            customerName: "",
            checkTime: []
        };
        _this.dataSet = [];
        return _this;
    }
    PolicyExecutionRecord.prototype.close = function () {
        this.model.caseNumber = '';
        this.model.customerName = '';
        this.model.checkTime = [];
    };
    PolicyExecutionRecord.prototype.mounted = function () {
        this.refreshData();
    };
    PolicyExecutionRecord.prototype.refreshData = function () {
        var _this = this;
        this.model.id = this.policyId;
        this.strategyConfigService
            .queryStrategyConfigDetailData(this.model, this.pageService)
            .subscribe(function (data) {
            _this.dataSet = data;
            // this.updateRunningData(data[0].runningTime);
        });
    };
    __decorate([
        CollectionExecutionModule.Mutation
    ], PolicyExecutionRecord.prototype, "updateRunningData", void 0);
    __decorate([
        Dependencies(StrategyConfigService)
    ], PolicyExecutionRecord.prototype, "strategyConfigService", void 0);
    __decorate([
        Dependencies(PageService)
    ], PolicyExecutionRecord.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], PolicyExecutionRecord.prototype, "sortService", void 0);
    __decorate([
        Prop({
            type: String
        })
    ], PolicyExecutionRecord.prototype, "policyId", void 0);
    __decorate([
        Emit("close")
    ], PolicyExecutionRecord.prototype, "close", null);
    PolicyExecutionRecord = __decorate([
        Component({
            components: {}
        })
    ], PolicyExecutionRecord);
    return PolicyExecutionRecord;
}(Vue));
export default PolicyExecutionRecord;
